import { render, staticRenderFns } from "./shelfSoonLists.vue?vue&type=template&id=42545a80&scoped=true"
import script from "./shelfSoonLists.vue?vue&type=script&lang=ts"
export * from "./shelfSoonLists.vue?vue&type=script&lang=ts"
import style0 from "./shelfSoonLists.vue?vue&type=style&index=0&id=42545a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42545a80",
  null
  
)

export default component.exports